import React from 'react'
import { useDidUpdate } from 'rooks'
import { Navigate, useNavigate } from 'react-router-dom'
import { useAppSelector } from 'store/hooks'

import Grid from '@material-ui/core/Grid'
import Button from 'components/Shared/Button/Button'

import { selectActiveWorkspace } from 'lib/helpers/selectors'
import { ROUTES } from '../../constants'

import Clear from '@material-ui/icons/Clear'
import './style.scss'
import DocumentRequestContainer from 'containers/DocumentRequest/DocumentRequestContainer'

interface Props {}

const DocumentRequestScreen: React.FC<Props> = props => {
  const navigate = useNavigate()

  const workspaceId = useAppSelector(selectActiveWorkspace)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useDidUpdate(() => {
    onRouteChange('error')
  }, [workspaceId])

  const onRouteChange = (action: string, id: number = 0) => {
    if (action === 'cancel') navigate(-1)
    if (action === 'accounting') navigate(ROUTES.ADD_ACCOUNTING)
    if (action === 'error') navigate(ROUTES.HOME, { replace: true })
  }

  if (!workspaceId) {
    return <Navigate to={ROUTES.HOME} />
  }

  return (
    <>
      <Grid
        container
        spacing={0}
        className="screen-add-taxes-payment-required-documents">
        <Grid item xs={12}>
          <div className="title-container">
            <h1>Solicitud de documentos</h1>
            <Button
              variant="hover"
              color="secondary"
              startIcon={<Clear />}
              onClick={() => onRouteChange('cancel')}>
              Cancelar
            </Button>
          </div>
        </Grid>
        <Grid item xs={12}>
          <DocumentRequestContainer
            workspaceId={workspaceId}
            onRedirect={onRouteChange}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default DocumentRequestScreen
